module.exports = __webpack_public_path__ + "static/img/empty-cart.c151e313.svg";